/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { useState } from "react";
import { IconButton } from "@mui/material";
import { ThumbUp, ThumbDown } from "@mui/icons-material";

const VoteButtons = ({ onVote }) => {
  const [vote, setVote] = useState(null);

  const handleVote = (type) => {
    setVote(type);
    if (onVote) {
      onVote(type === "up");
    }
  };

  return (
    <div
      style={{
        margin: "0px",
        border: "1px solid #e0e0e0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "50px",
        borderRadius: "5px",
        color:"#9b9b9b"
      }}
    >
      <IconButton 
        onClick={() => handleVote("up")} 
        style={{ padding: "5px", color: vote === "up" ? "#6e6e6e" : "inherit" }}
      >
        <ThumbUp />
      </IconButton>
      <div
        style={{
          borderLeft: "1px solid #e0e0e0",
          height: "20px",
          minWidth: "1px",
        }}
        aria-hidden="true"
      />
      <IconButton 
        onClick={() => handleVote("down")}
        style={{ padding: "5px", color: vote === "down" ? "#6e6e6e" : "inherit" }}
      >
        <ThumbDown />
      </IconButton>
    </div>
  );
};

export default VoteButtons;
